import { EMapActionTypes } from '../../actions/map';
import { EGetMapDataStatus, IMapState } from '../../types/map';
import { TReduxActions } from '../../types/redux';

export const defaultState: IMapState = {
  isOpen: false,
  data: {
    infrastructurePins: [],
    offerPins: [],
    status: EGetMapDataStatus.Initial,
  },
  activePin: undefined,
};

export const mapReducer = (state: IMapState = defaultState, action: TReduxActions) => {
  switch (action.type) {
    case EMapActionTypes.SetMapData:
      return {
        ...state,
        data: { ...action.payload, status: EGetMapDataStatus.Succeed },
      };

    case EMapActionTypes.SetMapDataLoading:
      return {
        ...state,
        data: { ...state.data, status: EGetMapDataStatus.Loading },
      };

    case EMapActionTypes.SetMapDataFailed:
      return {
        ...state,
        data: {
          offerPins: [],
          infrastructurePins: [],
          status: EGetMapDataStatus.Failed,
        },
      };

    case EMapActionTypes.OpenMap:
      return {
        ...state,
        isOpen: true,
      };

    case EMapActionTypes.CloseMap:
      return {
        ...state,
        isOpen: false,
        data: {
          offerPins: [],
          infrastructurePins: [],
          status: EGetMapDataStatus.Initial,
        },
      };

    case EMapActionTypes.SetActivePin:
      return {
        ...state,
        activePin: action.payload,
      };

    case EMapActionTypes.RemoveActivePin:
      return {
        ...state,
        activePin: undefined,
      };

    default:
      return state;
  }
};
